import React from 'react';
import './StyledCard.css';

/**
 * StyledCard — Standardized card wrapper
 * 
 * @param {'default'|'elevated'|'bordered'|'flat'} variant
 * @param {boolean} hoverable - Adds lift effect on hover
 * @param {boolean} noPadding - Remove default padding
 * @param {React.ReactNode} children
 */
const StyledCard = ({
  variant = 'default',
  hoverable = false,
  noPadding = false,
  children,
  className = '',
  ...props
}) => {
  const classes = [
    'ck-card',
    `ck-card--${variant}`,
    hoverable && 'ck-card--hoverable',
    noPadding && 'ck-card--no-padding',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

/**
 * StyledCard.Header — Optional card header with title, subtitle, action
 */
const StyledCardHeader = ({ icon, title, subtitle, action, children }) => (
  <div className="ck-card-header">
    <div className="ck-card-header-left">
      {icon && <span className="ck-card-header-icon">{icon}</span>}
      <div className="ck-card-header-text">
        {title && <h3 className="ck-card-title">{title}</h3>}
        {subtitle && <p className="ck-card-subtitle">{subtitle}</p>}
      </div>
    </div>
    {action && <div className="ck-card-header-action">{action}</div>}
    {children}
  </div>
);

/**
 * StyledCard.Body — Card body content
 */
const StyledCardBody = ({ children, className = '' }) => (
  <div className={`ck-card-body ${className}`}>
    {children}
  </div>
);

/**
 * StyledCard.Footer — Optional card footer
 */
const StyledCardFooter = ({ children, className = '' }) => (
  <div className={`ck-card-footer ${className}`}>
    {children}
  </div>
);

StyledCard.Header = StyledCardHeader;
StyledCard.Body = StyledCardBody;
StyledCard.Footer = StyledCardFooter;

export default StyledCard;
